import { Spinner } from "@justworkshr/milo-core";
import styles from "./LoadingSpinner.module.css";

export const LoadingSpinner = () => (
  <div className={styles.spinner}>
    <Spinner />
  </div>
);
